import { FeedbackPost, TaskPost } from '../../config/interfaces';

/**
 * Store sub context for round data
 */
const RoundContext = {
  isRoundStarted: false,
  isRoundCompleted: false,
  fetchingRound: false,
  loading: false,
  currentRound: {} as any,
  pendingIssues: [] as TaskPost[],
  pendingFeedbacks: [] as FeedbackPost[]
};

export default RoundContext;
